import React, { useEffect, useState } from "react";
import { Route, Switch } from "react-router-dom";
// import Editor from "./common/blog-editor";
import auth from "../../../services/authService";
// import BlogFooter from "./blogFooter";
import BlogNav from "./blogNav";

import BlogService from "../../../services/blogService";
import UserBlog from "./userBlog";
import BlogPage from "./blogPage";
import BlogBase from "./blogBase";

const Blog = () => {
  const [user, setUser] = useState({});
  const [blog, setBlog] = useState([]);

  // const [selectedGenre, setSelectedGenre] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    let user = auth.getCurrentUser();
    setUser(user);
    let blog = BlogService.getBlog();
    setBlog(blog);
  }, []);

  const handleSearch = (query) => {
    setSearchQuery(query);
  };

  return (
    <div className="container-fluid px-0" style={{ overflow: "hidden" }}>
      <div className="row mt-4 px-lg-5 pt-2">
        <div className="col-12 pt-2">
          <BlogNav
            value={searchQuery}
            user={user}
            handleSearch={handleSearch}
          ></BlogNav>
        </div>
      </div>
      <hr className="my-2" />

      <div className="">
        <Switch>
          <Route path="/blog/user/:userId" component={UserBlog}></Route>
          <Route path="/blog/post/:postId" component={BlogPage}></Route>
          <Route path="/blog" component={BlogBase}></Route>
        </Switch>
      </div>
    </div>
  );
};

export default Blog;
